import React from "react";
import ErrorPage from "../ErrorPage/ErrorPage";

const NotFoundPage = () => <ErrorPage message="Error 404 - Page not found" />;

// ts-prune-ignore-next
export default NotFoundPage;
